import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@bcc/components/ui/toast/toast";
import { useToast } from "@bcc/hooks/use-toast";
import { setToastIconTestId } from "@bcc/components/ui/toast/toast.utils";

const variantIconMap = {
  success: CheckCircle2,
  destructive: AlertCircle,
  warning: AlertTriangle,
  default: Info,
} as const;

const iconVariantClassMap: Partial<Record<string, string>> = {
  success: "text-success",
  warning: "text-warning",
  destructive: "text-destructive",
};

export const Toaster = () => {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant, ...props }) => {
        const Icon = variantIconMap[variant ?? "default"];
        const iconVariantClass = iconVariantClassMap[variant ?? "default"] ?? "";
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              <Icon
                className={`mt-0.5 h-5 w-5 shrink-0 ${iconVariantClass}`}
                data-testid={setToastIconTestId(variant ?? "default")}
                aria-hidden="true"
              />
              <div className="grid gap-1">
                {title ? <ToastTitle>{title}</ToastTitle> : null}
                {description ? <ToastDescription>{description}</ToastDescription> : null}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
